import { render, staticRenderFns } from "./MessagesView.vue?vue&type=template&id=b12f4d3c&scoped=true&"
import script from "./MessagesView.vue?vue&type=script&lang=js&"
export * from "./MessagesView.vue?vue&type=script&lang=js&"
import style0 from "./MessagesView.vue?vue&type=style&index=0&id=b12f4d3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12f4d3c",
  null
  
)

export default component.exports